<div class="tw-ml-3 tw-h-full">
  <div class="transparent-background"></div>
  <p class="tw-font-semibold tw-text-lg tw-text-main-text tw-mb-3">{{ greeting | translate: {user: currentUser.name} }} 👋🏻</p>
  <!-- TODO: Uncomment this iframe when the problem in public site is fixed -->
  <!-- <iframe class="info_extern" [src]="widget" frameborder="0"></iframe> -->
</div>